import React,{ Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dateFrom: '',
            dateTo: '',
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFieldChange(event) {
        const { value,name } = event.target;

        this.setState({
            [name]: value
        });
    }

    handleFormSubmit(e) {
        e.preventDefault();

        this.props.onSubmit(this.state);
    }

    render() {
        return (
            <form onSubmit={this.handleFormSubmit}>
                <Row>
                    <Col lg={6}>
                        <FieldGroup
                            type="date"
                            name="dateFrom"
                            label="Date From:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateFrom}
                        />
                    </Col>
                    <Col lg={6}>
                        <FieldGroup
                            type="date"
                            name="dateTo"
                            label="Date To:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateTo}
                        />
                    </Col>
                </Row>

                <Button type="submit" bsStyle="info" className="m-b-15" >Apply</Button>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/BidderECostCountry/components/Form/index.js